import {Alert, Snackbar} from '@mui/material';
import React, {createContext, useCallback, useContext, useState} from 'react';

const SnackbarContext = createContext();

export const SnackbarProvider = ({children}) => {
    const [open, setOpen] = useState(false);
    const [message, setMessage] = useState('');
    const [severity, setSeverity] = useState('info');
    const [variant, setVariant] = useState('');
    const [persist, setPersist] = useState(false);

    const showSnackbar = useCallback((message, options = {}) => {
        setMessage(message);
        setSeverity(options.severity || 'info');
        setVariant(options.variant || '');
        setPersist(!!options.persist);
        setOpen(true);
    }, []);

    const hideSnackbar = useCallback(() => {
        setOpen(false);
    }, []);

    const handleClose = (event, reason) => {
        if (persist && reason === 'clickaway') return;
        setOpen(false);
    };

    return (
        <SnackbarContext.Provider value={{showSnackbar, hideSnackbar}}>
            {children}
            <Snackbar
                open={open}
                anchorOrigin={{vertical: 'top', horizontal: 'center'}}
                autoHideDuration={persist ? null : 6000}
                sx={{zIndex: 9999}}
                onClose={handleClose}
            >
                <Alert
                    {...(['filled', 'outlined'].includes(variant) ? {variant} : {})}
                    severity={severity}
                    sx={{width: '100%', whiteSpace: 'pre-line'}}
                    onClose={persist ? undefined : handleClose}
                >
                    {message}
                </Alert>
            </Snackbar>
        </SnackbarContext.Provider>
    );
};

export const useSnackbar = () => {
    return useContext(SnackbarContext);
};
